import { cloneDeep } from 'lodash';
import { useCallback } from 'react';
import { IDailyReportMemberSettings } from 'types/DailyProjectReport/DailyReportMemberSettings';
import useMemberFeatureSettingsUpdate from '../member/useMemberFeatureSettingsUpdate';
import useMemberSettings from '../member/useMemberSettings';

export default function useDailyReportSettingsUpdate() {
  const memberSettings = useMemberSettings();
  const updateFeatureSettings = useMemberFeatureSettingsUpdate();

  return useCallback(
    <K extends keyof IDailyReportMemberSettings>(
      keysAndPayloads: { key: K; payload: IDailyReportMemberSettings[K] }[]
    ) => {
      const cloned = cloneDeep(memberSettings?.web?.features?.dailyProjectReport);

      const mapped = keysAndPayloads.reduce(
        (acc, cur) => ({
          ...acc,
          [cur.key]: cur.payload,
        }),
        cloned
      );

      return updateFeatureSettings('dailyProjectReport', mapped);
    },
    [memberSettings, updateFeatureSettings]
  );
}
